import { Link } from "@corpuscomplete/web/components/link";
import { Text } from "@corpuscomplete/web-ui/components/text";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@corpuscomplete/web-ui/components/sidebar";

/** Admin navigation rail for privileged routes and a link back to main app. */
export function AdminSidebar() {
  return (
    <Sidebar variant="inset">
      <SidebarRail />
      <SidebarHeader>
        <div className="flex items-center gap-2 p-1">
          <Text variant="sm" className="font-medium">
            Admin Panel
          </Text>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            <SidebarMenuItem>
              <Link to="/home">
                <SidebarMenuButton>
                  <Text variant="sm">← Back to App</Text>
                </SidebarMenuButton>
              </Link>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroup>
        <SidebarGroup>
          <SidebarGroupLabel>Management</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <Link to="/admin/users">
                  <SidebarMenuButton>
                    <Text variant="sm">Users</Text>
                  </SidebarMenuButton>
                </Link>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <Link to="/admin/ai-issues">
                  <SidebarMenuButton>
                    <Text variant="sm">AI Issues</Text>
                  </SidebarMenuButton>
                </Link>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
